import { ApplicationConfig,  provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient,provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
 

 import {
  TranslateHttpLoader,
  TRANSLATE_HTTP_LOADER_CONFIG
} from '@ngx-translate/http-loader';
import { LoaderInterceptor } from './interceptor/loader-interceptor';
import { AppSourceInterceptor } from './interceptor/app-source-interceptor';
import { ErrorRedirectInterceptor } from './interceptor/error-redirect-interceptor';
import { provideLottieOptions } from 'ngx-lottie';
 

 
export const appConfig: ApplicationConfig = {
  
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      fallbackLang: 'fr',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
        deps: [HttpClient]
      } 
      /*loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(),
        deps: [HttpClient]
      }*/
    }),
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AppSourceInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorRedirectInterceptor, multi: true },
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/assets/i18n/',
        suffix: '.json'
      }
    }

  ]
};
